export default {
      id: "angle-double-up-usage",
      viewBox: "0 0 320 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#angle-double-up",
      toString: function () {
        return this.url;
      }
    }